import { render, staticRenderFns } from "./BeforeInfo.vue?vue&type=template&id=215b5004&scoped=true"
import script from "./BeforeInfo.vue?vue&type=script&lang=js"
export * from "./BeforeInfo.vue?vue&type=script&lang=js"
import style0 from "./BeforeInfo.vue?vue&type=style&index=0&id=215b5004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b5004",
  null
  
)

export default component.exports